global.antRouter = '' // 全局得路由
global.IS_IDS4 = false // 默认false，表示使用JWT模式，如果true，表示使用ids4
global.appKey = '678782' //请求接口用appKey
global.appSecret = 'tyjmedseafsdfbeferbdfb'//请求接口用appSecret,请不要暴露

// global.antRouter = '' // 全局得路由
// global.IS_IDS4 = false // 默认false，表示使用JWT模式，如果true，表示使用ids4
// global.appKey = '678782' //请求接口用appKey
// global.appSecret = 'tyjmedseafsdfbeferbdfb'//请求接口用appSecret,请不要暴露